import Type from './Type';
export function isICode(node) {
    return node.type === Type.Code;
}
export default isICode;    //# sourceMappingURL=isICode.js.map
